import { auth } from '../firebase/config';

const ADMIN_API_URL = (import.meta.env.VITE_API_BASE_URL || '') + '/api/admin';

const getAuthToken = async () => {
    const user = auth.currentUser;
    if (!user) throw new Error("Usuario no autenticado");
    return await user.getIdToken();
};

const fetchWithAuth = async (url, options = {}) => {
    const token = await getAuthToken();
    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers
    };
    const response = await fetch(`${ADMIN_API_URL}${url}`, { ...options, headers });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error en la petición');
    }
    return response.json();
};

// Companies
export const getCompanies = () => fetchWithAuth('/companies');
export const createCompany = (data) => fetchWithAuth('/companies', { method: 'POST', body: JSON.stringify(data) });
export const updateCompany = (id, data) => fetchWithAuth(`/companies/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCompany = (id) => fetchWithAuth(`/companies/${id}`, { method: 'DELETE' });

// Clients
export const getClients = () => fetchWithAuth('/clients');
export const createClient = (data) => fetchWithAuth('/clients', { method: 'POST', body: JSON.stringify(data) });
export const updateClient = (id, data) => fetchWithAuth(`/clients/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteClient = (id) => fetchWithAuth(`/clients/${id}`, { method: 'DELETE' });

// Subscriptions
export const getClientSubscriptions = (clientId) => fetchWithAuth(`/clients/${clientId}/subscriptions`);
export const addClientSubscription = (clientId, planId) => fetchWithAuth(`/clients/${clientId}/subscriptions`, { method: 'POST', body: JSON.stringify({ PlanId: planId }) });
export const removeClientSubscription = (subscriptionId) => fetchWithAuth(`/subscriptions/${subscriptionId}`, { method: 'DELETE' });

// Transactions
export const getClientTransactions = (clientId) => fetchWithAuth(`/clients/${clientId}/transactions`);
export const approveTransaction = (transactionId) => fetchWithAuth(`/transactions/${transactionId}/approve`, { method: 'PUT' });

// Products
export const getProducts = () => fetchWithAuth('/products');
export const updateProduct = (id, data) => fetchWithAuth(`/products/${id}`, { method: 'PUT', body: JSON.stringify(data) });

// Plans Management
export const getPlansByProduct = (productId) => fetchWithAuth(`/products/${productId}/plans`);
export const createPlan = (data) => fetchWithAuth('/plans', { method: 'POST', body: JSON.stringify(data) });
export const updatePlan = (id, data) => fetchWithAuth(`/plans/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deletePlan = (id) => fetchWithAuth(`/plans/${id}`, { method: 'DELETE' });

// Features Management
export const getFeaturesByPlan = (planId) => fetchWithAuth(`/plans/${planId}/features`);
export const createFeature = (data) => fetchWithAuth('/features', { method: 'POST', body: JSON.stringify(data) });
export const updateFeature = (id, data) => fetchWithAuth(`/features/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteFeature = (id) => fetchWithAuth(`/features/${id}`, { method: 'DELETE' });

// Plans Helper
export const getAllPlans = () => fetchWithAuth('/plans/all');

// Knowledge Base: Webinars
export const getWebinars = () => fetchWithAuth('/webinars');
export const createWebinar = (data) => fetchWithAuth('/webinars', { method: 'POST', body: JSON.stringify(data) });
export const updateWebinar = (id, data) => fetchWithAuth(`/webinars/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteWebinar = (id) => fetchWithAuth(`/webinars/${id}`, { method: 'DELETE' });

// Knowledge Base: Capsules
export const getCapsules = () => fetchWithAuth('/capsules');
export const createCapsule = (data) => fetchWithAuth('/capsules', { method: 'POST', body: JSON.stringify(data) });
export const updateCapsule = (id, data) => fetchWithAuth(`/capsules/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCapsule = (id) => fetchWithAuth(`/capsules/${id}`, { method: 'DELETE' });

// Knowledge Base: Papers
export const getPapers = () => fetchWithAuth('/papers');
export const createPaper = (data) => fetchWithAuth('/papers', { method: 'POST', body: JSON.stringify(data) });
export const updatePaper = (id, data) => fetchWithAuth(`/papers/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deletePaper = (id) => fetchWithAuth(`/papers/${id}`, { method: 'DELETE' });

// Courses
export const getCourses = () => fetchWithAuth('/courses');
export const getCourseDetails = (id) => fetchWithAuth(`/courses/${id}`);
export const createCourse = (data) => fetchWithAuth('/courses', { method: 'POST', body: JSON.stringify(data) });
export const updateCourse = (id, data) => fetchWithAuth(`/courses/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteCourse = (id) => fetchWithAuth(`/courses/${id}`, { method: 'DELETE' });

// Modules
export const createModule = (data) => fetchWithAuth('/modules', { method: 'POST', body: JSON.stringify(data) });
export const updateModule = (id, data) => fetchWithAuth(`/modules/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteModule = (id) => fetchWithAuth(`/modules/${id}`, { method: 'DELETE' });

// Lessons
export const createLesson = (data) => fetchWithAuth('/lessons', { method: 'POST', body: JSON.stringify(data) });
export const updateLesson = (id, data) => fetchWithAuth(`/lessons/${id}`, { method: 'PUT', body: JSON.stringify(data) });
export const deleteLesson = (id) => fetchWithAuth(`/lessons/${id}`, { method: 'DELETE' });
